import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Toggle from 'react-bootstrap-toggle';
import Helmet from 'react-helmet';

import ProgressBar from '../../../../components/progress-bar';

import {
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';

import {
  getEmailAlert,
} from '../../SetupReducer';

import {
  updateEmailAlert,
} from '../../SetupActions';

class EmailAlertDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitting: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStatusToggle = this.handleStatusToggle.bind(this);
    this.handleAllowUnsubscribeToggle = this.handleAllowUnsubscribeToggle.bind(this);
  }

  componentDidMount() {
    this.initializeEmailAlert();
  }

  initializeEmailAlert() {
    this.setState({ loading: true }, () => {
      const { emailAlert, enableRecipients } = this.props;
      this.props.initialize({
        frequency: emailAlert.frequency,
        enabled: emailAlert.enabled,
        allowUnsubscribe: emailAlert.allow_unsubscribe,
        type: emailAlert.type,
        ...(enableRecipients ? {
          adminRecipient: emailAlert.admin_recipient,
          managerRecipient: emailAlert.manager_recipient,
        } : {}),
      });
      this.setState({ loading: false });
    });
  }

  handleSubmit(input) {
    const { organization, enableRecipients } = this.props;
    this.setState({ submitting: true }, () => {
      const emailAlert = {
        frequency: input.frequency,
        enabled: input.enabled,
        type: input.type,
        allow_unsubscribe: input.allowUnsubscribe,
        ...(enableRecipients ? {
          admin_recipient: input.adminRecipient,
          manager_recipient: input.managerRecipient,
        } : {}),
      };
      this.props.dispatch(updateEmailAlert(organization._id, emailAlert))
        .then(
          (newEmailAlert) => {
            this.props.change('emailAlert', newEmailAlert);
            this.props.initialize({
              frequency: newEmailAlert.frequency,
              enabled: newEmailAlert.enabled,
              type: newEmailAlert.type,
              allowUnsubscribe: newEmailAlert.allow_unsubscribe,
              ...(enableRecipients ? {
                adminRecipient: newEmailAlert.admin_recipient,
                managerRecipient: newEmailAlert.manager_recipient,
              } : {}),
            });
            this.setState({ submitting: false });
            const el = (<div>Email alert updated successfully</div>);
            this.context.addNotification(el, {
              type: 'success',
              autoClose: true,
            });
          },
          (_error) => {
            this.setState({ submitting: false });
            const el = (<div>Email alert update failed</div>);
            this.context.addNotification(el, {
              type: 'error',
              autoClose: true,
            });
          },
        );
    });
  }

  handleStatusToggle() {
    const { enabled } = this.props;
    this.props.change('enabled', !enabled);
  }

  handleAllowUnsubscribeToggle() {
    const { allowUnsubscribe } = this.props;
    this.props.change('allowUnsubscribe', !allowUnsubscribe);
  }

  getDirty() {
    const {
      emailAlert,
      selectedFrequency,
      enabled,
      allowUnsubscribe,
      enableRecipients,
      adminRecipient,
      managerRecipient,
    } = this.props;

    return (emailAlert?.frequency !== selectedFrequency) ||
           (emailAlert?.enabled !== enabled) ||
           (emailAlert?.allow_unsubscribe !== allowUnsubscribe) ||
           (enableRecipients &&
             (emailAlert?.admin_recipient !== adminRecipient || emailAlert?.manager_recipient !== managerRecipient)
           );
  }

  /** Render the frequency field that determines how often the email digest is sent */
  renderFrequencyField() {
    const { selectedFrequency } = this.props;
    const { submitting } = this.state;

    const frequencyOptions = [
      { label: 'Weekly', value: 'weekly' },
      { label: 'Bi-Weekly', value: 'biweekly' },
      { label: 'Monthly', value: 'monthly' },
    ];

    const helpText = {
      weekly: 'Send this email digest weekly on Friday mornings for the previous 7 days',
      biweekly: 'Send this email digest every two weeks on Friday mornings for the previous 14 days',
      monthly: 'Send this email digest every Month on the first day of the month for the previous month',
    };

    return (
      <div>
        <ControlLabel>Frequency</ControlLabel>
        <FormGroup>
          {frequencyOptions.map((option) => (
            <span key={option.value}>
              <label>
                <Field
                  name="frequency"
                  component="input"
                  type="radio"
                  value={option.value}
                  disabled={submitting}
                /> {option.label}
              </label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          ))}
          <HelpBlock>
            {helpText[selectedFrequency]}
          </HelpBlock>
        </FormGroup>
      </div>
    );
  }

  /** Render the toggle that determines whether the email digest is enabled or disabled */
  renderStatusToggle() {
    const { enabled } = this.props;
    const { submitting } = this.state;

    const helpText = {
      enabled: 'Email digests are enabled; users will receive an email digest based on the frequency you select below',
      disabled: 'Email digests are disabled; users will not receive an email digest',
    };

    return (
      <div>
        <FormGroup>
          <ControlLabel>Email Digests</ControlLabel>
          {' '}
          <Toggle
            onClick={this.handleStatusToggle}
            on={<span>Enabled</span>}
            off={<span>Disabled</span>}
            onstyle='success'
            size='xs'
            offstyle='danger'
            active={enabled}
            disabled={submitting}
          />
          <HelpBlock>
            {helpText[enabled ? 'enabled' : 'disabled']}
          </HelpBlock>
        </FormGroup>
      </div>
    );
  }

  renderAllowUnsubscribeToggle() {
    const { allowUnsubscribe } = this.props;
    const { submitting } = this.state;

    const helpText = {
      on: 'Display the unsubscribe option in the email footer of the email and allow the recipient to unsubscribe from this email digest',
      off: 'Display a message in the email footer that the email is a required communication',
    };

    return (
      <div>
        <FormGroup>
          <ControlLabel>Allow Unsubscribe</ControlLabel>
          {' '}
          <Toggle
            onClick={this.handleAllowUnsubscribeToggle}
            on={<span>On</span>}
            off={<span>Off</span>}
            onstyle='success'
            size='xs'
            offstyle='danger'
            active={allowUnsubscribe}
            disabled={submitting}
          />
          <HelpBlock>
            {helpText[allowUnsubscribe ? 'on' : 'off']}
          </HelpBlock>
        </FormGroup>
      </div>
    );
  }

  renderRecipientsMultiSelect() {
    const { submitting } = this.state;

    const options = [
      { label: 'Sales Manager', key: 'managerRecipient' },
      { label: 'Admin', key: 'adminRecipient' },
    ];

    return (
      <div>
        <ControlLabel>Recipients</ControlLabel>
        {options.map((option) => {
          const { key, label } = option;
          return (
            <div key={key}>
              <label>
                <Field
                  name={key}
                  component="input"
                  type="checkbox"
                  disabled={submitting}
                /> {label}
              </label>
              <br />
            </div>
          );
        })}
        <HelpBlock>Select the TruSales users that will receive the email</HelpBlock>
      </div>
    );
  }

  renderForm() {
    const { handleSubmit, title, subtitle, enableRecipients } = this.props;
    const { submitting } = this.state;
    const dirty = this.getDirty();
    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="panel panel-default">
          <div className="panel-heading">
            {title}
          </div>
          <div className="panel-body">
            <p>{subtitle}</p>
            <Field name="type" component="input" type="hidden" />
            {this.renderStatusToggle()}
            {this.renderFrequencyField()}
            {this.renderAllowUnsubscribeToggle()}
            {enableRecipients && this.renderRecipientsMultiSelect()}
          </div> 
          <div className="panel-footer">
            <div className="row">
              <div className="col-sm-12">
                <div className="pull-right">
                  {dirty && (
                    <span className="text-danger animated flash" style={{ paddingTop: 5 }}>
                      <Fa name="exclamation-triangle" /> You have unsaved data. &nbsp;
                    </span>
                  )}
                  <Button bsStyle="primary" type="submit" disabled={!dirty || submitting}>
                    {submitting && <span><Fa name="spinner" spin /> Updating</span>}
                    {!submitting && <span><Fa name="edit" /> Update</span>}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  render() {
    const { loading } = this.state;
    const { title } = this.props;
    return (
      <div>
        <Helmet title={`${title} | Organization Setup`} />
        {loading && <ProgressBar />}
        {!loading && this.renderForm()}
      </div>
    );
  }
}

const selector = formValueSelector('emailAlert');

function mapStateToProps(state, ownProps) {
  const defaultEmailAlertValues = {
    type: ownProps.type,
    enabled: false,
    frequency: 'weekly',
    allow_unsubscribe: false,
    ...(ownProps.enableRecipients ? {
      admin_recipient: false,
      manager_recipient: false,
    } : {}),
  };

  return {
    emailAlert: {
      ...defaultEmailAlertValues,
      ...(getEmailAlert(state, ownProps.type) || {}),
    },
    selectedFrequency: selector(state, 'frequency'),
    enabled: selector(state, 'enabled'),
    allowUnsubscribe: selector(state, 'allowUnsubscribe'),
    ...(ownProps.enableRecipients ? {
      adminRecipient: selector(state, 'adminRecipient'),
      managerRecipient: selector(state, 'managerRecipient'),
    } : {}),
    organization: getUserCurrentOrganization(state),
  };
}

EmailAlertDetailPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedFrequency: PropTypes.string,
  enabled: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  emailAlert: PropTypes.shape({
    frequency: PropTypes.string,
    enabled: PropTypes.bool,
    type: PropTypes.string,
    manager_recipient: PropTypes.bool,
    admin_recipient: PropTypes.bool,
    allow_unsubscribe: PropTypes.bool,
  }),
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  enableRecipients: PropTypes.bool,
  managerRecipient: PropTypes.bool,
  adminRecipient: PropTypes.bool,
  allowUnsubscribe: PropTypes.bool,
};
EmailAlertDetailPage.defaultProps = {
  selectedFrequency: 'weekly',
  enabled: false,
  enableRecipients: false,
  allowUnsubscribe: false,
};
EmailAlertDetailPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

const BuyerFeedbackForm = reduxForm({
  form: 'emailAlert',
})(EmailAlertDetailPage);

export default connect(mapStateToProps)(BuyerFeedbackForm);
